<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Small" });
import { t } from "svelte-i18n";
export let label = "";
export let color = "subtle";
</script>

{#if 'default' in $$slots || Boolean(label)}
    <small class = { `text-xxs s8-${ color }`}>
        {#if 'default' in $$slots }
            <slot>Hello World</slot>
        {/if}
        { $t(label.toString()) }
    </small>
{/if}

<style>

    small.s8-error {
        color: #EF233B;
    }

    small.s8-warning {
        color: #EFC923;
    }

    small.s8-success {
        color: #44835F;
    }

    small.s8-info {
        color: #446083;
    }

    small.s8-subtle {
        color: #979691;
    }

    small.s8-dark {
        color: #272711;
    }

    small.s8-light {
        color: #FFFFFF;
    }</style>